import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editCitoyenRequest: ['response'],
    editCitoyenSuccess: ['response', 'loading'],
    editCitoyenFailure: ['error'],
})

export const editCitoyenTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
})

const editCitoyenRequest = state => state.merge({ response: null })
const editCitoyenSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
    })

const editCitoyenFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_CITOYEN_REQUEST]: editCitoyenRequest,
    [Types.EDIT_CITOYEN_SUCCESS]: editCitoyenSuccess,
    [Types.EDIT_CITOYEN_FAILURE]: editCitoyenFailure,
})
